import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
        <RankingSection />
        <CardsSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}